<template>
  <div class="phone">
    <p class="phone__details">
      <span class="phone__details--symbol"></span>
      {{ number }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer_Phone',
  props: {
    number: String
  }
}
</script>

<style lang="scss">
  .phone {

    .phone__details--symbol {
        height: 0.9em;
        margin: 0 0 -0.4% 0;
        content: url('../../assets/phone.svg');
    }
  }
</style>
